import * as tslib_1 from "tslib";
import { observable, action, computed } from 'mobx';
import { Loadable, loading } from '../utils/loading';
import DocumentsApi from '../services/DocumentsApi';
var documentTypes = null;
var DocumentStore = /** @class */ (function (_super) {
    tslib_1.__extends(DocumentStore, _super);
    function DocumentStore(task) {
        var _this = _super.call(this) || this;
        _this.task = task;
        _this.documents = [];
        _this.selectedDocumentType = 0;
        return _this;
    }
    DocumentStore.prototype.loadDocuments = function () {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var types, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(documentTypes === null)) return [3 /*break*/, 2];
                        return [4 /*yield*/, DocumentsApi.getDocumentTypes()];
                    case 1:
                        types = _b.sent();
                        documentTypes = [{ id: 0, name: 'Összes' }].concat(types);
                        _b.label = 2;
                    case 2:
                        _a = this;
                        return [4 /*yield*/, DocumentsApi.getAllDocuments(this.task.id)];
                    case 3:
                        _a.documents = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DocumentStore.prototype.uploadDocument = function (file, description) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, DocumentsApi.uploadDocument({
                            type: this.selectedDocumentType,
                            userId: this.task.userId,
                            relationId: this.task.headId,
                            file: file,
                            description: description
                        })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.loadDocuments()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DocumentStore.prototype.selectDocumentType = function (documentType) {
        this.selectedDocumentType = documentType;
    };
    Object.defineProperty(DocumentStore.prototype, "visibleDocuments", {
        get: function () {
            var _this = this;
            if (this.selectedDocumentType === 0) {
                return this.documents || [];
            }
            if (this.documents && this.selectedDocumentType && this.documents.length > 0) {
                return this.documents.filter(function (i) { return i.type === _this.selectedDocumentType; });
            }
            return [];
        },
        enumerable: true,
        configurable: true
    });
    DocumentStore.prototype.deleteDocument = function (documentId) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, DocumentsApi.deleteDocument(documentId)];
                    case 1:
                        result = _a.sent();
                        if (result) {
                            this.documents = this.documents.filter(function (i) { return i.id !== documentId; });
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    };
    DocumentStore.prototype.getDocumentCountByType = function (documentType) {
        if (!this.documents) {
            return 0;
        }
        if (documentType === 0) {
            return this.documents.length;
        }
        return this.documents.filter(function (i) { return i.type === documentType; }).length;
    };
    tslib_1.__decorate([
        observable
    ], DocumentStore.prototype, "documents", void 0);
    tslib_1.__decorate([
        observable
    ], DocumentStore.prototype, "selectedDocumentType", void 0);
    tslib_1.__decorate([
        action.bound,
        loading
    ], DocumentStore.prototype, "loadDocuments", null);
    tslib_1.__decorate([
        action.bound,
        loading
    ], DocumentStore.prototype, "uploadDocument", null);
    tslib_1.__decorate([
        action.bound
    ], DocumentStore.prototype, "selectDocumentType", null);
    tslib_1.__decorate([
        computed
    ], DocumentStore.prototype, "visibleDocuments", null);
    tslib_1.__decorate([
        action.bound
    ], DocumentStore.prototype, "deleteDocument", null);
    return DocumentStore;
}(Loadable));
export { DocumentStore, documentTypes };



//////////////////
// WEBPACK FOOTER
// ./src/store/DocumentStore.ts
// module id = 296
// module chunks = 0